<template>
  <b-container class="home-container container-xl">
    <b-row col="12" class="mb-4 text-left">
      <b-col sm="12" md="12" lg="9" xl="9">
        <h1>KKV Energiaköltség és Beruházás Támogatási Program 2022-2023</h1>
        <h2 class="my-4" style="color: #00903C; ">
          Szállashely-szolgáltatás, vendéglátásban működő vállalatok számára
        </h2>
        <p style="font-size: 16px">
          A támogatási kérelem benyújtása előzetes <b>regisztrációhoz kötött.</b> A regisztrációra ügyfélkapus
          bejelentkezést követően van mód.
        </p>
        <b-button
          class="mt-2 px-4"
          variant="primary"
          style="padding-top:12px;"
          href="https://vali.hu/static/Felhivas_20251208_KKV_Energia.pdf"
        >
          Tovább a pályázati felhíváshoz
        </b-button>
      </b-col>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col>
        <h2>Meddig lehet benyújtani támogatási kérelmet?</h2>
      </b-col>
    </b-row>
    <b-row class="mb-4 text-right">
      <b-col lg="3">
        <div class="d-flex flex-nowrap align-items-center justify-content-end">
          <p class="col-2 step-icon">
            1.
          </p>
        </div>
        <p><strong>Pályázati felhíváshoz kapcsolódó regisztráció határideje:</strong></p>
        <p style="color: #00903c;">2023. június 30. 19:00</p>
      </b-col>
      <b-col lg="3" class="text-right">
        <div class="d-flex flex-nowrap align-items-center justify-content-end">
          <p class="col-2 step-icon">
            2.
          </p>
        </div>
        <div>
          <p>
            <strong>Jogosultsági űrlapok beküldésének határideje:</strong>
          </p>
          <p style="color: #00903c;">2023. október 13.</p>
        </div>
        <div>
          <p>
            (Támogató által kérelmezett javítások, korrekciók hiánytalan elvégzésének és beküldésének véghatárideje, ami
            a jogosultsági ellenőrzés összes folyamatban lévő feladatára vonatkozik)
          </p>
        </div>
      </b-col>
      <b-col lg="3" class="text-right">
        <div class="d-flex flex-nowrap align-items-center justify-content-end">
          <p class="col-2 step-icon">
            3.
          </p>
        </div>
        <div>
          <p>
            <strong>Támogatási kérelem benyújtásának határideje energiaköltség támogatására:</strong>
          </p>
          <p style="color: #00903c;">2023. október 31.</p>
        </div>
      </b-col>
      <b-col lg="3">
        <div class="d-flex flex-nowrap align-items-center justify-content-end">
          <p class="col-2 step-icon">
            4.
          </p>
        </div>
        <p>
          <strong>Támogatási kérelem benyújtásának határideje önerő kiegészítő támogatására (B komponens):</strong>
        </p>
        <p style="color: #00903c;">2024. március 31.</p>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col cols="12" lg="6" class="services-wrapper border-right mt-4 text-left">
        <h3 class="title">Készítse elő az alábbi dokumentumokat a támogatás igényléséhez</h3>
        <ul>
          <li>Aláírási címpéldány / hitelesített aláírásminta (cégnyilvántartásba bejegyzett vállalkozások esetén)</li>
          <li>
            A 2021. évi szálláshely-szolgáltatás, illetve vendéglátás tevékenységből származó árbevételt alátámasztó
            könyvelési analitikák, bizonylatok – ezek alapján szükséges megadni az értékeket a pályázati kitöltő
            felületen, amennyiben a főtevékenység nem szálláshely-szolgáltatás, illetve vendéglátás tevékenységből
            származik de a 2021. évi értékesítés nettó árbevételének legnagyobb része szálláshely-szolgáltatás, illetve
            vendéglátás tevékenységből származik
          </li>
          <li>
            A 2021. évi energiaköltségeket alátámasztó könyvelési analitikák, bizonylatok – ezek alapján szükséges
            megadni az értékeket a pályázati kitöltő felületen a 2 %-os korlát vizsgálatához
          </li>
          <li>
            A 2022. január, február, március hónapokra vonatkozó villamos energia és/vagy földgáz és/vagy távhő számlák
            az azonos adószám alatt nyilvántartott székhely, továbbá telephely(ek), fióktelep(ek) vonatkozásában.
          </li>
        </ul>
      </b-col>
      <b-col cols="12" lg="6" class="services-wrapper border-left mt-4 text-left">
        <h3 class="title">Regisztráció előtti teendők</h3>
        <p>
          <strong>
            Kérjük, a regisztráció megkezdése előtt a pályázó vállalkozás hivatalos képviselőjével szíveskedjen
            cégszerűen aláíratni a pályázati felületre feltöltendő alábbi dokumentumokat:
          </strong>
        </p>
        <ul>
          <li>
            <a href="#jogi_szemely_nyilatkozata">jogi személy nyilatkozat</a>,
            <a href="#egyeni_vallalkozo_nyilatkozata">egyéni vállalkozó nyilatkozata</a> – erre minden esetben szükség
            van
          </li>
          <li>
            <a href="#osszeferhetetlenseg_nyilatkozat">összeférhetetlenségi nyilatkozat</a> – erre minden esetben
            szükség van
          </li>
          <li><a href="#meghatalmazas">meghatalmazás</a> – amennyiben ez releváns</li>
        </ul>
        <p>
          <strong>
            Kérjük továbbá, hogy a regisztráció megkezdése előtt szíveskedjenek áttekinteni azon nyilatkozatok körét,
            amelyeket a pályázati felületen szükséges kitölteniük. A nyilatkozatokat pdf formátumban megtalálják a
            letölthető dokumentumok között.
          </strong>
        </p>
        <b-button class="mt-2 px-4" variant="primary" style="padding-top:12px; width:300px;" href="#doc_downloads">
          Nyilatkozatok listája
        </b-button>
      </b-col>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col>
        <h2>Hogyan jelentkezhet a támogatási programra?</h2>
      </b-col>
    </b-row>
    <b-row class="text-left mb-5">
      <b-col lg="4">
        <p class="step-image-paragraph-to-start-of-line">
          <img src="../assets/img/icons/step_first_white.svg" /><strong>Regisztráció</strong>
        </p>
        <p class="mb-4">
          Regisztráljon a pályázat weboldalán. A regisztrációhoz ügyfélkapus bejelentkezésre lesz szükség
        </p>
      </b-col>
      <b-col lg="4">
        <p class="step-image-paragraph-to-start-of-line">
          <img src="../assets/img/icons/step_second_white.svg" /><strong>Banki felhatalmazó levél beküldése</strong>
        </p>
        <p class="mb-4">
          A hatályos Felhívás alapján rögzített határidők szerint, kérjük a banki felhatalmazó levelet feltölteni a
          pályázati felületre, továbbá kérjük, küldje el postai úton is az MGFÜ számára.
        </p>
      </b-col>
      <b-col lg="4">
        <p class="step-image-paragraph-to-start-of-line">
          <img src="../assets/img/icons/step_third_white.svg" /><strong>Támogatási kérelem benyújtása</strong>
        </p>
        <p class="mb-4">
          A támogatási kérelem benyújtásához töltse le a szükséges nyilatkozatokat és dokumentumokat, majd tölse fel
          őket a pályázat kitöltő felületen.
        </p>
      </b-col>
    </b-row>

    <b-row class="attention-grabbing-box text-left mb-4 pb-2" style="padding: 25px">
      <b-col lg="1">
        <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2834_34966)">
            <path
              d="M90.6689 -0.0126948H45.3952C19.9732 1.37752 -0.187562 22.5096 -0.0105622 48.3017C0.170938 74.3344 21.3764 95.662 47.4232 96.009C72.9982 96.344 94.0657 76.7258 96.0142 51.7484V5.32484C96.014 4.62365 95.8756 3.92936 95.6068 3.28162C95.3381 2.63389 94.9443 2.04539 94.4479 1.54975C93.9516 1.0541 93.3624 0.661012 92.714 0.392926C92.0656 0.124841 91.3707 -0.0129901 90.6689 -0.0126948ZM92.1997 50.6894C90.8422 74.0721 71.4397 92.6073 47.7022 92.6073C23.0864 92.6073 3.12594 72.6654 3.12594 48.0641C3.12594 24.6455 21.2129 5.44925 44.1817 3.65658H86.2567C87.8328 3.65718 89.3442 4.28329 90.4584 5.39723C91.5726 6.51117 92.1984 8.02172 92.1982 9.59667L92.1997 50.6894Z"
              fill="#BA3B46"
              fill-opacity="0.6"
            />
            <path
              d="M71.8238 19.1758H44.3918C29.9093 20.8291 18.6562 33.1207 18.6562 48.0391C18.6562 64.0854 31.677 77.0928 47.7315 77.0928C62.8403 77.0928 75.2565 65.5813 76.668 50.8525V24.0164C76.6682 23.3807 76.543 22.7512 76.2997 22.1638C76.0563 21.5764 75.6995 21.0427 75.2496 20.5931C74.7997 20.1436 74.2656 19.7871 73.6778 19.5439C73.09 19.3007 72.46 19.1756 71.8238 19.1758ZM72.789 50.0529C71.76 63.318 60.4245 73.6933 46.7708 73.2039C33.7387 72.7333 23.1158 62.1931 22.5578 49.1753C21.9758 35.6216 32.1518 24.3027 45.2625 23.0444H67.1948C67.929 23.044 68.6561 23.1881 69.3347 23.4686C70.0132 23.749 70.6298 24.1602 71.1492 24.6787C71.6687 25.1972 72.0809 25.8129 72.3622 26.4907C72.6436 27.1684 72.7886 27.8948 72.789 28.6285V50.0529Z"
              fill="#BA3B46"
              fill-opacity="0.6"
            />
          </g>
          <defs>
            <clipPath id="clip0_2834_34966">
              <rect width="96" height="96" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </b-col>
      <b-col lg="11" class="pl-5">
        <p>
          <strong
            >Felhívjuk figyelmüket, hogy a sikeres regisztráció önmagában nem jelenti a támogatás odaítélését. A
            Pályázati felhívásban meghatározott, rendelkezésre álló keretösszeg a vállalkozások által benyújtott
            támogatási kérelmekben foglalt összegek alapján odaítélt és kiállított támogatói okiratban foglalt
            támogatási összegek szerint kerül felhasználásra, a regisztráció sorrendjével nincs összefüggésben</strong
          >
        </p>
      </b-col>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col>
        <h2>Támogatási kérelem benyújtásának előfeltétele - banki felhatalmazó levél beküldése</h2>
      </b-col>
    </b-row>
    <b-row class="text-left mb-4">
      <b-col class="services-wrapper text-left">
        <p class="mb-4">
          A támogatási kérelem pályázati kitöltő felületen történő rögzítése a biztosítékként szolgáló banki
          felhatalmazó levelek online beküldését követően már lehetővé válik. Azonban
          <b>
            a támogatási kérelem csak abban esetben válik beküldhetővé, ha a Támogató a hozzá postai úton beérkezett
            felhatalmazó leveleket megkapta és az ellenőrzés során sem az online felületre feltöltött adatokban, sem a
            papír alapú dokumentumokban nem talált hibát, hiányt.
          </b>
          A Támogató az ellenőrzés eredményéről a támogatási rendszerben értesítést küld a Pályázó részére, adott
          esetben hiánypótlást ír elő. A felhatalmazó leveleket postai úton az alábbi címre szükséges megküldeni:
        </p>
        <address class="mb-4" style="color:#00903c;">
          MGFÜ Magyar Gazdaságfejlesztési Ügynökség - 1074 Budapest, Rákóczi út 70-72.
        </address>
        <p class="mb-0">
          A könnyebb beazonosíthatóság érdekében kérjük, a borítékon szíveskedjenek feltüntetni a Felhívás címét és
          regisztrációs számukat. Javasoljuk, hogy a felületre történő belépés előtt tekintse át a Letölthető
          dokumentumok menüpontban elérhető Kitöltési útmutató című dokumentum vonatkozó részét.
        </p>
      </b-col>
    </b-row>
    <b-row class="mb-5">
      <b-button
        class="mt-2 px-4"
        variant="primary"
        style="padding-top:12px; width:400px;"
        href="https://energiatamogatas.vali.hu/szallas/kau-login"
      >
        Tovább a pályázat kitöltő felületre
      </b-button>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col lg="7">
        <h2>Támogatás igénybevételéhez szükséges nyilatkozatok és dokumentumok</h2>
      </b-col>
    </b-row>
    <b-row id="doc_downloads" cols="12" class="text-left mb-4">
      <b-col lg="6">
        <p class="mb-4"><strong>Letölthető dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Felhivas_20251208_KKV_Energia.pdf"
              >
                Pályázati Felhívás
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Felhivas_mod_KKV_Energiakoltseg_Tamogatasi_Program.pdf"
              >
                Pályázati Felhívás (archív)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_A_szalloda_vendeglatas.pdf"
              >
                “A” Pályázás menete
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_palyazas_menete_B_szalloda_vendeglatas.pdf"
              >
                “B” Pályázás menete
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_A_koltsegtamogatas_ismerteto_szalloda_vendeglatas.pdf"
              >
                “A” Költségtámogatás ismertető
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/E-intenziv_KKV_Tamogatasi_Program_B_onero_tamogatas_ismerteto_szalloda_vendeglatas.pdf"
              >
                “B” Önerő támogatás ismertető
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/palyazati_felulet-kitoltesi_utmutato_szallashely_vendeglatas.pdf"
              >
                Kitöltési útmutató
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li id="meghatalmazas">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Meghatalmazas_MGFU.docx"
              >
                Meghatalmazás
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Energiatamogatas_Felhat_level_sablon_MGFU.docx"
              >
                Felhatalmazó levél
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Szakmai_beszamolo-palyazoi_kitoltesi_segedlet.pdf"
              >
                Szakmai beszámoló - Pályázói kitöltési segédlet
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col lg="6">
        <p class="mb-4"><strong>Letölthető dokumentumok</strong></p>
        <div class="download">
          <ul>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/GYIK_Szallashely_vendeglatas.pdf"
              >
                GYIK
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Bankszamlaszamokrol_szolo_nyilatkozat_MGFU.docx"
              >
                Bankszámlaszámokról szóló nyilatkozat
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li id="egyeni_vallalkozo_nyilatkozata">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Egyeni_vallalkozo_nyilatkozata_MGFU.docx"
              >
                Egyéni Vállalkozó nyilatkozata
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Egyeni_vallalkozo_nyilatkozata_segedlet.pdf"
              >
                Egyéni vállalkozó nyilatkozata (segédlet)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li id="jogi_szemely_nyilatkozata">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Jogi_szemely_nyilatkozata_MGFU.docx"
              >
                Jogi személy nyilatkozata
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Jogi_szemely_nyilatkozata_segedlet.pdf"
              >
                Jogi személy nyilatkozata (segédlet)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li id="osszeferhetetlenseg_nyilatkozat">
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/osszeferhetetlensegi_nyilatkozat_MGFU.xlsx"
              >
                Összeférhetetlenségi nyilatkozat
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/osszeferhetetlensegi_nyilatkozat_segedlet.xlsx"
              >
                Összeférhetetlenségi nyilatkozat (segédlet)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
            <li>
              <a
                class="services-button-wrapper"
                download
                target="_blank"
                href="https://vali.hu/static/Foglalkoztatotti_letszam_segedlet.pdf"
              >
                Foglalkoztatotti létszám (segédlet)
                <img src="../assets/img/icons/download.svg" />
              </a>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>

    <b-row class="text-left mb-4">
      <b-col>
        <h2 class="mb-4">Ügyfélszolgálat elérhetősége</h2>
        <p>
          Az MGFÜ Magyar Gazdaságfejlesztési Ügynökség ügyfélszolgálata az alábbi elérhetőségeken áll szíves
          rendelkezésére:
        </p>
      </b-col>
    </b-row>
    <b-row class="text-left services-wrapper-bottom mb-4">
      <b-col lg="6" class="border-right">
        <p><strong style="color: #00903c;">Ügyfélszolgálat várja megkeresését az alábbi munkarendben:</strong></p>
        <p>Hétfőtől csütörtökig: 8:00 – 17:00</p>
        <p>Pénteken: 8:00 – 14:30</p>
      </b-col>
      <b-col lg="6" class="border-left">
        <p><strong style="color: #00903c;">Ügyfélszolgálat elérhetősége:</strong></p>
        <p><img class="mr-2" src="../assets/img/icons/homephone.svg" /> +36 1 312 2213</p>
        <p>
          <img class="mr-2" src="../assets/img/icons/envelope.svg" /> <a href="mailto:info@mgfu.hu">info@mgfu.hu</a>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {}
</script>

<style scoped>
.attention-grabbing-box {
  border: 3px solid #ba3b46;
  border-radius: 30px 0px 30px 30px;
}

ul {
  list-style-image: url('../assets/img/icons/tick_mark.svg');
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}
.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

.services-wrapper {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
}

.services-wrapper-bottom {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 24px;
  padding-bottom: 0px;
}

.title {
  color: #00903c;
  margin-bottom: 24px;
}

.border-left {
  border-left: 12px solid white !important;
}
.border-right {
  border-right: 12px solid white !important;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

.step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 32px;
  min-height: 32px;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  font-weight: 600;
  font-size: 16px;
}
</style>
